<script src="//unpkg.com/v-viewer/dist/v-viewer.js"></script>
<template>
  <div>
    <div v-if="loading || !formLoaded">
      <span class="spinner"></span>
    </div>
    <div v-if="!loading && formLoaded">
      <b-form @submit.stop.prevent="onSubmit" :class="{
          'p-3 box-shadow2 rounded': !isDarkMode,
          'dark-div p-3 box-shadow2 rounded': isDarkMode
        }">

        
         <b-row>
          <b-col sm="12" lg="6">
       
        <b-form-group id="group-mobile" label-for="input-mobile">
          <template v-slot:label>
            Customer Mobile Number
            <span class="text-danger">*</span>
          </template>
          <b-input-group>
            <b-form-input
              id="input-mobile"
              v-model="form.mobile"
              type="number"
              :disabled="formType !== 'new'"
              placeholder="Enter Mobile Number"
              :state="$v.form.mobile.$dirty ? !$v.form.mobile.$error : null"
              :class="{
                  'box-shadow3 bg-light text-dark': !isDarkMode,
                  'bg-dark text-light placeholder-light dark-input-fix': isDarkMode
                }"
            ></b-form-input>
            <b-input-group-append v-if="formType === 'new' && form.mobile.length > 6">
              <b-button variant="success" @click="fetchUserInfo">Fetch User Data</b-button>
            </b-input-group-append>
          </b-input-group>

          <b-form-text id="input-mobile-help">Mobile Number must be a valid 10 digit long number.</b-form-text>

          <b-form-invalid-feedback id="input-email-invalid">Please enter valid mobile number.</b-form-invalid-feedback>
        </b-form-group>

             </b-col>
              <b-col sm="12" lg="6">

              
        <b-form-group id="group-name" label-for="input-name">
          <template v-slot:label>
            Customer Name
            <span class="text-danger">*</span>
          </template>

          <b-form-input
            id="input-name"
            type="text"
            v-model="form.name"
            :state="$v.form.name.$dirty ? !$v.form.name.$error : null"
            placeholder="Enter Name"
            :class="{
                  'box-shadow3 bg-light text-dark': !isDarkMode,
                  'bg-dark text-light placeholder-light dark-input-fix': isDarkMode
                }"
          ></b-form-input>

          <b-form-invalid-feedback id="input-name-invalid">Please enter name.</b-form-invalid-feedback>
        </b-form-group>

        </b-col>
             </b-row>


              <b-row>
          <b-col sm="12" lg="6">
        <b-form-group id="group-address" label-for="input-address">
          <template v-slot:label>
            Customer Address
            <span class="text-danger">*</span>
          </template>

          <b-form-textarea
            id="input-address"
            type="text"
            v-model="form.address"
            :state="$v.form.address.$dirty ? !$v.form.address.$error : null"
            placeholder="Enter Customer Address"

            :class="{
                  'box-shadow3 bg-light text-dark': !isDarkMode,
                  'bg-dark text-light placeholder-light dark-input-fix': isDarkMode
                }"
          ></b-form-textarea>

          <b-form-text id="input-address-help">Address must be more than 10 characters.</b-form-text>

          <b-form-invalid-feedback id="input-address-invalid">Please enter valid address.</b-form-invalid-feedback>
        </b-form-group>

        </b-col>
         <b-col sm="12" lg="6">

       
        <b-form-group id="group-products" label-for="input-products">
          <template v-slot:label> Select Store Id <span class="text-danger">*</span> </template>
          <multiselect
            v-model="selectedStoreId"
            ref="multiselect"
            placeholder="Select Store Id"
            :options="userStoreIds"
            :disabled="formType !== 'new'"
            :class="{
                  'box-shadow3': !isDarkMode,
                  darkMode: isDarkMode
                }"
          >
          </multiselect>
        </b-form-group>

          </b-col>
        </b-row>
        <b-form-group id="group-products" label-for="input-products">
          <template v-slot:label> Add Products </template>
          <b-form-row v-for="index in value.length + 1" :key="index - 1">
            <b-col cols="8" @click="selectedMulti(index - 1)">
              <multiselect
                :disabled="index != value.length + 1"
                v-model="value[index - 1]"
                ref="multiselect"
                tag-placeholder="Add this as new product"
                placeholder="Add Products"
                label="productName"
                :custom-label="labelWithPrice"
                track-by="productName"
                :options="productOptions"
                :searchable="true"
                :internal-search="false"
                :clear-on-select="true"
                :close-on-select="true"
                :options-limit="20"
                :hide-selected="true"
                :loading="isLoading"
                :multiple="false"
                :taggable="true"
                @search-change="asyncFind"
                @tag="addTag"

                :class="{
                  'box-shadow3': !isDarkMode,
                  darkMode: isDarkMode
                }"
              >
              </multiselect>
            </b-col>
            <b-col cols="1" v-bind:style="{ padding: '8px', textAlign: 'center' }">X</b-col>
            <b-col cols="2">
              <b-form-input
                v-bind:style="{ height: '40px !important' }"
                type="number"
                ref="inputquantity"
                v-model="quantity[index - 1]"
                placeholder="1"
                :class="{
                  'box-shadow3 bg-light text-dark': !isDarkMode,
                  'bg-dark text-light placeholder-light dark-input-fix': isDarkMode
                }"
              ></b-form-input>
            </b-col>
            <b-col cols="1"> <b-button @click="deleteProduct(index)" variant="danger">Delete</b-button> </b-col>
          </b-form-row>
        </b-form-group>

        <b-form-group id="group-description" label-for="input-description">
          <template v-slot:label> Order Description </template>

          <b-form-textarea
            id="input-description"
            type="text"
            rows="1"
            v-model="form.description"
            :state="$v.form.description.$dirty ? !$v.form.description.$error : null"
            placeholder="Enter Order Description If Any"
            :class="{
                  'box-shadow3 bg-light text-dark': !isDarkMode,
                  'bg-dark text-light placeholder-light dark-input-fix': isDarkMode
                }"
          ></b-form-textarea>

          <b-form-text id="input-description-help">Description must be more than 1 characters.</b-form-text>

          <b-form-invalid-feedback id="input-description-invalid"
            >Please enter valid description.</b-form-invalid-feedback
          >
        </b-form-group>

        <template v-if="errorMessages">
          <b-row class="mb-2">
            <b-col class="text-danger message-col">{{ errorMessages }}</b-col>
          </b-row>
        </template>

        <template v-if="productError">
          <b-row class="mb-2">
            <b-col class="text-danger message-col">{{ productError }}</b-col>
          </b-row>
        </template>

        <template v-if="storeError">
          <b-row class="mb-2">
            <b-col class="text-danger message-col">{{ storeError }}</b-col>
          </b-row>
        </template>

        <template v-if="this.formType !== 'new'">
          <div style="display: flex">
            <b-form-group id="group-name" label-for="input-name">
              <template v-slot:label> Order Created At </template>
              <b-form-input
                id="input-name"
                type="text"
                :disabled="true"
                style="max-width: 70%"
                v-model="form.createdAt"
                :state="$v.form.name.$dirty ? !$v.form.name.$error : null"
                :class="{
                  'box-shadow3 bg-light text-dark': !isDarkMode,
                  'bg-dark text-light placeholder-light dark-input-fix': isDarkMode
                }"
              ></b-form-input>
            </b-form-group>
            <b-form-group id="group-name" label-for="input-name">
              <template v-slot:label> Acknowledged At </template>
              <b-form-input
                id="input-name"
                type="text"
                style="max-width: 70%"
                :disabled="true"
                v-model="form.acknowledgedTime"
                :state="$v.form.name.$dirty ? !$v.form.name.$error : null"
                :class="{
                  'box-shadow3 bg-light text-dark': !isDarkMode,
                  'bg-dark text-light placeholder-light dark-input-fix': isDarkMode
                }"
              ></b-form-input>
            </b-form-group>
            <b-form-group id="group-name" label-for="input-name">
              <template v-slot:label> Packaged </template>
              <b-form-input
                id="input-name"
                type="text"
                style="max-width: 70%"
                :disabled="true"
                v-model="form.packagedTime"
                :state="$v.form.name.$dirty ? !$v.form.name.$error : null"
                :class="{
                  'box-shadow3 bg-light text-dark': !isDarkMode,
                  'bg-dark text-light placeholder-light dark-input-fix': isDarkMode
                }"
              ></b-form-input>
            </b-form-group>
            <b-form-group id="group-name" label-for="input-name">
              <template v-slot:label> Bill Generated At </template>
              <b-form-input
                id="input-name"
                type="text"
                style="max-width: 70%"
                :disabled="true"
                v-model="form.posPingTime"
                :state="$v.form.name.$dirty ? !$v.form.name.$error : null"
                :class="{
                  'box-shadow3 bg-light text-dark': !isDarkMode,
                  'bg-dark text-light placeholder-light dark-input-fix': isDarkMode
                }"
              ></b-form-input>
            </b-form-group>
            <b-form-group id="group-name" label-for="input-name">
              <template v-slot:label> Delivered At </template>
              <b-form-input
                id="input-name"
                type="text"
                style="max-width: 70%"
                :disabled="true"
                v-model="form.actualDeliveredTime"
                :state="$v.form.name.$dirty ? !$v.form.name.$error : null"
                :class="{
                  'box-shadow3 bg-light text-dark': !isDarkMode,
                  'bg-dark text-light placeholder-light dark-input-fix': isDarkMode
                }"
              ></b-form-input>
            </b-form-group>
          </div>
          <label v-if="order.imageURL != ''" style="font-weight: bold">Order Images</label>
          <div v-viewer>
            <template v-for="image in order.imageURL">
              <div :key="image" class="imageview">
                <label> <img :src="image" class="image"/></label>
              </div>
            </template>
          </div>
          <label v-if="order.deliveryPics != ''" style="font-weight: bold">Delivery Images</label>
          <div v-viewer>
            <template v-for="image in order.deliveryPics">
              <div :key="image" class="imageview">
                <label> <img :src="image" class="image"/></label>
              </div>
            </template>
          </div>
          <label style="font-weight: bold">POS Items</label>

          <table-box
            :columns="columns"
            :rows="pos"
            :baseUrl="baseUrl"
            :loading="loading"
            emptyText="No pos items found."
          >
          </table-box>
        </template>

        <b-row>
          <b-col>
            <b-button type="submit" size="sm" variant="success" :disabled="loading">
              <span class="spinner spinner-white" v-if="loading"></span>
              <font-awesome-icon :icon="['fas', 'save']" class="mr-1" />Save
            </b-button>
          </b-col>
          <b-col class="text-right">
            <b-button size="sm" variant="warning" :to="{ path: `${listUrl}` }">
              <font-awesome-icon :icon="['fas', 'long-arrow-alt-left']" class="mr-1" />Back to list
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </div>
    <link href="//unpkg.com/viewerjs/dist/viewer.css" rel="stylesheet" />
  </div>
</template>

<script>
import { numeric, maxLength, required, minLength } from 'vuelidate/lib/validators';
import Multiselect from 'vue-multiselect';
import { mapGetters, mapState, mapActions } from 'vuex';
import _ from 'lodash';
import Catalogue from '../model/catalogue';
import VueViewer from 'v-viewer';
import Vue from 'vue';
import TableBox from './TableBox.vue';

Vue.use(VueViewer);

export default {
  name: 'OrderFormBox',
  props: {
    listUrl: String,
    userType: String,
    formType: String,
    customerMobile: Number,
    customerName: String,
    customerAddress: String,
    userId: {
      type: Number,
      required: false
    }
  },
  components: {
    Multiselect,
    TableBox
  },
  metaInfo() {
    return {
      meta: [
        {
          name: 'description',
          content: this.metaDescription
        }
      ]
    };
  },
  data() {
    return {
      storeOptions: [],

      columns: [
        {
          type: 'row_num',
          headerText: 'UOM',
          class: { 'text-center': true },
          textKey: 'UOM',
          width: '20%'
        },
        {
          type: 'string',
          headerText: 'Amount',
          class: { 'text-center': true },
          textKey: 'amount',
          width: '10%'
        },
        {
          type: 'string',
          headerText: 'Discount',
          class: { 'text-center': true },
          textKey: 'disc',
          width: '10%'
        },
        {
          type: 'string',
          headerText: 'Hsn Code',
          class: { 'text-center': true },
          textKey: 'hsnCode',
          width: '10%'
        },
        {
          type: 'string',
          headerText: 'Category',
          class: { 'text-center': true },
          textKey: 'itemCategory',
          width: '15%'
        },
        {
          type: 'string',
          headerText: 'Item Name',
          class: { 'text-center': true },
          textKey: 'itemName',
          width: '15%'
        },
        {
          type: 'string',
          headerText: 'MRP',
          class: { 'text-center': true },
          textKey: 'mrp',
          width: '10%'
        },
        {
          type: 'string',
          headerText: 'Quantity',
          class: { 'text-center': true },
          textKey: 'quantity',
          width: '10%'
        }
      ],
      title: '',
      formLoaded: false,
      form: {
        mobile: null,
        name: null,
        address: null,
        description: null,
        storeid: null
      },
      productError: null,
      storeError: null,
      value: [],
      quantity: [1],
      selectedMultiBoxIndex: null,
      productOptions: [],
      isLoading: false,
      timeout: null,
      selectedStoreId: ''
    };
  },
  validations() {
    const formValidation = {
      mobile: {
        required,
        numeric,
        maxLength: maxLength(10),
        minLength: minLength(10)
      },
      name: {
        required
      },
      address: {
        required,
        minLength: minLength(10)
      },
      description: {}
    };
    return { form: formValidation };
  },
  mounted() {
    this.$nextTick(async () => {
      // Code that will run only after the entire view has been re-rendered
      if (this.formType === 'new') {
        this.form.mobile = this.customerMobile;
        this.form.name = this.customerName;
        this.form.address = this.customerAddress;
        this.formLoaded = true;
        this.$v.$touch(); // Set initial validation
        this.$v.$reset(); // Reset $dirty
      }
    });
  },
  computed: {
    metaDescription() {
      return this.formType === 'new' ? 'Add new order' : 'Update order';
    },
    userStoreIds() {
      if (this.user.storeids.length === 1) {
        this.selectedStoreId = this.user.storeids[0];
      }
      return this.user.storeids;
    },
    ...mapGetters('alert', ['errorMessages']),
    ...mapState('order', ['loading', 'order']),
    ...mapState('auth', ['user']),
    ...mapState('catalogue', ['productsList']),
    ...mapState('darkMode',['isDarkMode']),
    pos() {
      return this.order.posItems.map(i => ({
        ...i
      }));
    }
  },
  methods: {
    labelWithPrice(product) {
      if (product.productName !== undefined && product.price !== undefined) {
        return `${product.productName} - ₹ ${product.price}`;
      } else {
        return `${product.productName}`;
      }
    },
    fetchUserInfo() {
      this.$emit('fetch-user', { customerMobile: this.form.mobile });
    },
    onSubmit() {
      this.productError = null;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      }
      if (_.isEmpty(this.value)) {
        this.productError = 'Please add atleast one product';
        return false;
      }
      if (this.selectedStoreId === '') {
        this.storeError = 'Please select a store';
        return false;
      }

      const products = this.value.map(
        (product, index) => `${product.productName}:::${this.quantity[index] ? this.quantity[index] : 1}`
      );
      const order = {
        customerMobile: parseInt(this.form.mobile, 10),
        name: this.form.name,
        address: this.form.address,
        description: this.form.description,
        storeid: this.selectedStoreId,
        source: this.ifCallCenterExecutive() ? 'CALL_CENTER_ENTRY' : 'SINGLE_FORM_ENTRY',
        orderMode: this.ifCallCenterExecutive() ?this.user.company==="SRL"?'CALL_CENTER_ENTRY':"OUTBOUND": 'DIRECT_POS_ENTRY',
        products
      };
      if (this.formType === 'new') {
        this.$emit('add', { order });
      } else {
        this.$emit('edit', { order });
      }
      return false;
    },
    ifCallCenterExecutive() {
      if (this.user) {
        const filterSubAdmin = this.user.roles.filter(role => role.name === 'CALL_CENTER_EXECUTIVE');
        if (filterSubAdmin.length > 0) {
          return true;
        }
      }
      return false;
    },
    deleteProduct(index) {
      this.value.splice(index - 1, 1);
    },
    asyncFind(query) {
      clearTimeout(this.timeout);
      const customQuery = {
        query,
        storeid: this.selectedStoreId
      };
      if (query.length > 2) {
        this.timeout = setTimeout(() => {
          this.$emit('find', { customQuery });
          this.isLoading = true;
        }, 300);
      }
    },
    selectedMulti(index) {
      this.selectedMultiBoxIndex = index;
    },
    addTag(newTag) {
      const tag = new Catalogue({
        productName: newTag,
        id: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000)
      });
      this.productOptions.push(tag);
      this.value.push(tag);
      setTimeout(() => {
        this.$refs.inputquantity[this.value.length - 1].$refs.input.focus();
      }, 300);
    }
  },
  watch: {
    value() {
      setTimeout(() => {
        this.$refs.inputquantity[this.value.length - 1].$refs.input.focus();
      }, 300);
    },
    customerName(_newValue) {
      this.form.name = _newValue;
    },
    customerAddress(_newValue) {
      this.form.address = _newValue;
    },
    productsList(_newValue) {
      this.productOptions = _newValue;
      this.isLoading = false;
    },
    order(_newValue, _oldValue) {
      if (!this.order.id) {
        return;
      }
      // Loaded order, assign to form

      this.form.mobile = this.order.customerMobile;
      this.form.name = this.order.name;
      this.form.address = this.order.address;
      this.selectedStoreId = this.order.storeid;
      this.form.description = this.order.description;
      this.form.createdAt = this.order.createdAt ? this.order.createdAt : null;
      this.form.acknowledgedTime = this.order.acknowledgedTime ? this.order.acknowledgedTime : 'NA';
      this.form.packagedTime = this.order.packagedTime ? this.order.packagedTime : 'NA';
      this.form.posPingTime = this.order.posPingTime ? this.order.posPingTime : 'NA';
      this.form.actualDeliveredTime = this.order.actualDeliveredTime ? this.order.actualDeliveredTime : 'NA';
      const value = this.order.products.split(',').map((product, index) => {
        this.quantity[index] = product.split(':::').length > 1 ? product.split(':::')[1] : 1;
        return {
          productName: product.split(':::').length > 1 ? product.split(':::')[0] : product,
          id: product.substring(0, 2) + Math.floor(Math.random() * 10000000)
        };
      });
      this.value = value;

      this.formLoaded = true;

      this.$v.$touch(); // Set initial validation
      this.$v.$reset(); // Reset $dirty
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.imageview {
  display: inline-flex;
}

.image {
  height: 200px;
  width: 200px;
  cursor: pointer;
  margin: 5px;
  display: inline-block;
}
</style>
